/**
 * Lightweight client-side growth-event tracker.
 * 
 * Emits to POST /api/growth/track with an anon_id stored in
 * localStorage (so we can attribute multiple events from the
 * same device). Auth token is auto-picked up by axios defaults
 * where available.
 */
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const ANON_KEY = 'eventdrop_anon_id';

function getAnonId() {
  try {
    let id = localStorage.getItem(ANON_KEY);
    if (!id) {
      id = `anon_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
      localStorage.setItem(ANON_KEY, id);
    }
    return id;
  } catch { return null; }
}

export async function trackGrowth(event, payload = {}) {
  try {
    await axios.post(`${API}/growth/track`, {
      event,
      anon_id: getAnonId(),
      ...payload,
    });
  } catch { /* never block the UI on analytics */ }
}

export { getAnonId };
